// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__73m0a","title":"ClientReferral_title__v6KDT","itemText":"ClientReferral_itemText__2aoCo"};